document.addEventListener("DOMContentLoaded", () => {

  const panel = document.querySelector(".js-calculator");
  if (!panel) return;

  const initialInput  = panel.querySelector(".js-calc-initial");
  const monthlyInput  = panel.querySelector(".js-calc-monthly");
  const rateInput     = panel.querySelector(".js-calc-rate");
  const yearsInput    = panel.querySelector(".js-calc-years");
  const yearsValue    = panel.querySelector(".js-calc-years-value");
  const finalEl       = panel.querySelector(".js-calc-final");
  const contributedEl = panel.querySelector(".js-calc-contributed");
  const growthEl      = panel.querySelector(".js-calc-growth");
  const chartSvg      = panel.querySelector(".js-calc-chart");

  const formatCurrency = (value) => "$" + Math.round(value).toLocaleString("en-US");

  // Monthly compounding: contribution added at the end of each month, on
  // top of that month's growth — a standard, conservative ordering for
  // this kind of illustrative projection.
  const projectBalances = (initial, monthly, annualRate, years) => {
    const monthlyRate = annualRate / 100 / 12;
    let balance = initial;
    const yearlyBalances = [balance];

    for (let month = 1; month <= years * 12; month++) {
      balance = balance * (1 + monthlyRate) + monthly;
      if (month % 12 === 0) {
        yearlyBalances.push(balance);
      }
    }

    return yearlyBalances;
  };

  // Built with createElementNS/setAttribute rather than chartSvg.innerHTML
  // = "<rect .../>" — Element.innerHTML on an SVG element only reliably
  // parses SVG markup in newer browser versions (e.g. Safari added support
  // in 16.4, 2023); older/other engines silently leave the chart empty.
  const SVG_NS = "http://www.w3.org/2000/svg";

  const drawChart = (yearlyBalances) => {
    const width = 600;
    const height = 240;
    const max = Math.max(...yearlyBalances, 1);
    const barGap = 3;
    const barWidth = (width / yearlyBalances.length) - barGap;

    while (chartSvg.firstChild) {
      chartSvg.removeChild(chartSvg.firstChild);
    }

    yearlyBalances.forEach((value, i) => {
      const barHeight = Math.max((value / max) * (height - 4), 1);
      const x = i * (barWidth + barGap);
      const y = height - barHeight;

      const rect = document.createElementNS(SVG_NS, "rect");
      rect.setAttribute("x", x.toFixed(1));
      rect.setAttribute("y", y.toFixed(1));
      rect.setAttribute("width", barWidth.toFixed(1));
      rect.setAttribute("height", barHeight.toFixed(1));
      rect.setAttribute("rx", "1");
      rect.setAttribute("class", "aiw-calculator__bar");
      chartSvg.appendChild(rect);
    });
  };

  const compute = () => {
    const initial = Math.max(0, parseFloat(initialInput.value) || 0);
    const monthly = Math.max(0, parseFloat(monthlyInput.value) || 0);
    const rate    = Math.max(0, parseFloat(rateInput.value) || 0);
    const years   = Math.max(1, parseInt(yearsInput.value, 10) || 1);

    yearsValue.textContent = years;

    const yearlyBalances = projectBalances(initial, monthly, rate, years);
    const finalBalance   = yearlyBalances[yearlyBalances.length - 1];
    const contributed    = initial + monthly * years * 12;
    const growth          = finalBalance - contributed;

    finalEl.textContent       = formatCurrency(finalBalance);
    contributedEl.textContent = formatCurrency(contributed);
    growthEl.textContent      = formatCurrency(growth);

    drawChart(yearlyBalances);
  };

  [initialInput, monthlyInput, rateInput, yearsInput].forEach((input) => {
    input.addEventListener("input", compute);
  });

  compute();

});
